module.exports = __webpack_public_path__ + "img/09.748879d2.png";